let Util = {
    getQueryVariable: function getQueryVariable(variable) {
        // var query = window.location.search.substring(1);
        // var vars = query.split("&");
        // for (var i = 0; i < vars.length; i++) {
        //     var pair = vars[i].split("=");
        //     if (pair[0] == variable) { return pair[1]; }
        // }
        // return (false);
        return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    },
    addCookie : function (name, value, time) {
        var strSec = getSec(time);
        var exp = new Date();
        exp.setTime(exp.getTime() + strSec * 1);    
        //设置cookie的名称、值、失效时间
        document.cookie = name + "=" + value + ";expires="+ exp.toGMTString();  
    },
    getCookie : function (name) {
        //获取当前所有cookie
        var strCookies = document.cookie;
        //截取变成cookie数组
        var array = strCookies.split(';');
        //循环每个cookie
        for (var i = 0; i < array.length; i++) {
            //将cookie截取成两部分
            var item = array[i].split("=");
            //判断cookie的name 是否相等
            if (item[0] == name) {
                return item[1];
            }
        }
        return null;
    },
    delCookie : function (name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        //获取cookie是否存在
        var value = getCookie(name);
        if (value != null) {
            document.cookie = name + "=" + value + ";expires="+ exp.toUTCString();
        }
    },
    //fmt 'yyyy-MM-dd hh:mm:ss'
    formatDate(date,fmt) {
        if(/(y+)/.test(fmt)){
            fmt = fmt.replace(RegExp.$1,(date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        let o ={
            'M+': date.getMonth()+1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        };
        for (let k in o){
            if(new RegExp(`(${k})`).test(fmt))
            {
                let str = o[k] + '';
                fmt=fmt.replace(RegExp.$1,(RegExp.$1.length===1)?str:this.padLeftZero(str))
            }
     
        }
        return fmt
    },
    padLeftZero(str){
        return ('00' + str).substr(str.length)
    }

}

export default Util;